<template>
  <div class="seniorCard" :class="this.$root.whatEev=='miniprogram'?'mini':''">
    <div class="headerIcon">
      <img
        :src="seniorDetail.avatar||defaultHead"
        alt="avatar"
      >
    </div>
    <div class="seniorInfo">
      <h2>{{seniorDetail.nickName}}</h2>
      <div class="schoolDetail">
        <span>{{seniorDetail.pgCollege}}</span>
        <span>{{seniorDetail.pgSubject}}</span>
        <span>{{seniorDetail.enrolYear}}</span>
      </div>
      <ul v-if="keywords">
        <li
          v-for="(item,index) in keywords"
          :key="index"
        >{{item}}</li>
      </ul>
      <div
        class="consult"
        @click="openChat()"
      >我有问题咨询TA</div>
    </div>

  </div>
</template>

<script>
import { seniorOpenChat } from '@/utils/tools';
import wx from 'weixin-js-sdk';

export default {
  component: {
  },
  props: {
    seniorDetail: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      defaultHead: require('@/assets/img/majorSenior/headIcon.png'), // 默认头像
      keywords: null,

    };
  },
  watch: {
    seniorDetail: {
      handler(val) {
        if (JSON.stringify(val) !== '{}') {
          this.keywords = val.keywords.split(',');
        }
      },
      immediate: true,
    },

  },

  computed: {

  },
  mounted() {
  },

  methods: {

    // 我有问题咨询TA
    openChat() {
      if (this.$root.whatEev == 'miniprogram') {
        if (this.$root.$data.zxMini) {
          const href = window.location.href;
          if (href.includes('mobile-test.iqihang')) {
            wx.miniProgram.navigateTo({ url: '/subPackages/aiChatWebview/index?probeId=38' });
          }else {
            wx.miniProgram.navigateTo({ url: '/subPackages/aiChatWebview/index?probeId=58' });
          }
        } else {
          wx.miniProgram.navigateTo({ url: '/subPackages/aiChatWebview/index?probeId=33'});
        }
      } else {
         if(this.$route.query.source==='oneToOne'){
          this.openOneToOne();
        }else{
          seniorOpenChat(this);
        }s
      }
    },
    openOneToOne(){
           const url =
        'https://pg-chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=66e39b2a165a0b00012736b4';
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url,
          },
          false,
        );
        return;
      }
      if (this.$root.$data.miniprogram) {
        const jumpUrl = `/subPackages/webView/webView?url=${encodeURIComponent(url)}`;
        wx.miniProgram.navigateTo({
          url: jumpUrl,
        });
        return;
      }
      window.open(url);
    }

  },
};

</script>

<style lang="scss" scoped>
.seniorCard {
  position: relative;
  box-sizing: border-box;
  width: 678px;
  margin: 100px auto 0 auto;
  padding-bottom: 36px;
  background: #fff;
  border-radius: 14px;
  .headerIcon {
    position: absolute;
    top: 0%;
    left: 50%;
    width: 109px;
    height: 109px;
    border-radius: 50%;
    box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
    transform: translate(-50%, -50%);
    img {
      width: 109px;
      height: 109px;
      border-radius: 50%;
    }
  }
  .seniorInfo {
    h2 {
      width: 100%;
      height: 120px;
      padding-top: 74px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
      text-align: center;
      background: url('../../../assets/img/majorSenior/bg.png') no-repeat;
      background-size: 100% 100%;
    }
    .schoolDetail {
      padding: 18px 36px;
      font-size: 0;
      text-align: center;
      span {
        position: relative;
        margin-right: 25px;
        color: #666;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
        word-wrap: break-word;
        word-break: break-all;
        &::before {
          position: absolute;
          top: 4px;
          left: -14px;
          width: 2px;
          height: 22px;
          background: #666;
          content: '';
        }
        &:first-child::before {
          content: none;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      li {
        margin-right: 10px;
        margin-bottom: 14px;
        padding: 7px;
        color: #fe9766;
        font-weight: 400;
        font-size: 22px;
        line-height: 31px;
        background: #fef5f1;
        border-radius: 7px;
      }
    }
    .consult {
      width: 210px;
      height: 58px;
      margin: 26px auto 0 auto;
      color: #fff;
      font-weight: 500;
      font-size: 22px;
      line-height: 58px;
      text-align: center;
      background: #ff7f41;
      border-radius: 29px;
    }
  }
}
.mini{
  margin: 0 auto 0 auto;
}
</style>
